import { render, staticRenderFns } from "./ScreenDark.vue?vue&type=template&id=83ff1c26&scoped=true&"
import script from "./ScreenDark.vue?vue&type=script&lang=js&"
export * from "./ScreenDark.vue?vue&type=script&lang=js&"
import style0 from "./ScreenDark.vue?vue&type=style&index=0&id=83ff1c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ff1c26",
  null
  
)

export default component.exports